<template>
  <div class="message_design text-center">
    <span> Authorizing User please wait... </span>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "SSO",
  data() {
    return {};
  },
  methods: {
    ...mapActions([
      "ssoAuthentication",
      "updateUserInfo",
      "updateToken",
      "updateAuthcode",
    ]),
  },
  created() {
    this.updateToken(null);
    this.updateAuthcode(null);
    this.ssoAuthentication();
  },
};
</script>
<style scoped>
.message_design {
  background-color: #0f8575;
  color: white;
  padding: 10px;
  margin: 10px 0;
}
</style>